import { useAppSelector } from "../hooks";
import classes from "../styles/Container.module.css";
import { useEffect } from "react";
import Commander from "../commander";

const Container: React.FC = () => {
  const { width, height, pixelRatio } = useAppSelector((state) => state.layout);
  useEffect(() => Commander.setAsLoaded(), []);

  return (
    <main id="elysium-container" className={classes.container}>
      <canvas
        id="elysium-canvas"
        width={width * pixelRatio}
        height={height * pixelRatio}
      >
        HTML5 canvas appears to be unsupported in the current browser.
        <br />
        Please try updating or use a different browser.
      </canvas>
    </main>
  );
};

export default Container;
